<template>
    <v-container
      fill-height
      justify-content-start
      class="menu-section-width pa-0 section-padding"
    >
      <v-layout column v-if="!!page">
        <v-flex class="app-scroll-section pa-2">
        <!-- Contenido de la página según tipo -->
        <component :is="pageComponent" />
        </v-flex>
      </v-layout>
      <v-layout v-else column justify-center align-center>
        <v-progress-circular color="primary" indeterminate />
      </v-layout>
    </v-container>
  </template>
  
<script>
import { mapState } from 'vuex'
import { pageTypes } from '@/config'

export default {
  data () {
    return {
      loading: false,
    }
  },
  created () {
    this.loading = true
    this.$store.dispatch('pages/get', { id: this.$route.params.pageId}).catch(() => {}).finally(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapState({
      page: state => state.pages.page,
    }),
    pageComponent () {
      if (!this.page) return null
      let componentName = null
      switch (this.page.type) {
      case pageTypes.CONTENT:
      case pageTypes.SERVICE:
        componentName = 'full-cover-image'
        break
      default:
        componentName = this.page.type.toLowerCase()
        break
      }
      return componentName
    },
  },
  beforeDestroy () {
    this.$store.commit('pages/setPage', null)
  },
  components: {
    navigation: () => import('@/components/view-components/webapp-pages/page-types/Navigation.vue'),
    FullCoverImage: () => import('@/components/view-components/webapp-pages/FullCoverImage.vue'),
  },
}
</script>
  
  